module.exports = __webpack_public_path__ + "img/tbi_bank.2b742771.png";